module.exports = __webpack_public_path__ + "static/media/site_logo_no_alpha.6a7391dd.png";